import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import api from "../lib/api";

export default function WhatsAppFab() {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.get("/site-settings").then(({ data }) => setCfg(data)).catch(() => {});
  }, []);

  if (!cfg || cfg.whatsapp_enabled === false || !cfg.whatsapp) return null;
  const num = cfg.whatsapp.replace(/[^0-9]/g, "");
  if (!num) return null;
  const href = `https://wa.me/${num}?text=${encodeURIComponent("Halo SkorUp, saya butuh bantuan 🙏")}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat WhatsApp"
      className="fixed bottom-20 right-4 sm:bottom-6 sm:right-6 z-[60] group flex items-center gap-2"
    >
      <span className="hidden sm:block bg-su-surface border-2 border-su-border text-su-text font-heading font-bold text-sm px-3 py-2 rounded-xl shadow-lg opacity-0 group-hover:opacity-100 transition-opacity">
        Butuh bantuan?
      </span>
      <span className="w-14 h-14 rounded-full grid place-items-center text-white shadow-[0_6px_20px_rgba(37,211,102,0.5)] bg-[#25D366] transition-transform group-hover:scale-110">
        <MessageCircle className="w-7 h-7 fill-current" />
      </span>
    </a>
  );
}
